import React, { useEffect, useState } from "react";
import { Box, TablePagination } from "@mui/material";
import QueryBox from "../../PIDSessionView/ChatPanel/QueryBox";
import { useHistory } from "react-router-dom";
import { PID_URL } from "../../../../utils/routes";
import { useDispatch, useSelector } from "react-redux";
import { getFilesByStatus } from "../../../../core/repo/fileRepo";
import PIDFilesList from "./PIDFilesList";

function NewPIDEntry() {
  const history = useHistory();
  const dispatch = useDispatch();
  const { selectedDomain } = useSelector((state) => state.domain);
  const [filesData, setFilesData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(0);

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const filesResponse = await dispatch(
        getFilesByStatus("", "P&ID", page + 1, selectedDomain.id)
      );
      setFilesData(filesResponse);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page, selectedDomain]);

  const handleQuery = (query) => {
    let queryParams = new URLSearchParams();
    queryParams.set("query", query);
    queryParams.set("fileId", "1T4031-PR-5AE.9.-.9.01");
    history.push(`${PID_URL}?${queryParams.toString()}`);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  return (
    <Box
      p={3}
      height={"100%"}
      display={"flex"}
      flexDirection={"column"}
      // display={"flex"}
      // justifyContent={"center"}
      // alignItems={"center"}
      width={"100%"}
      maxWidth={720}
      margin={"0 auto"}>
      <QueryBox isNewSession={true} handleQuery={handleQuery} />
      <Box mb={3} />
      {filesData && filesData.files && filesData.files.length > 0 && (
        <PIDFilesList files={filesData.files} />
      )}
      {filesData?.total > 0 && (
        <TablePagination
          component={Box}
          count={filesData?.total}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={50}
          rowsPerPageOptions={[50]}
        />
      )}
    </Box>
  );
}

export default NewPIDEntry;
